/**
 * WebSocket Connection Test for Codebase 1
 * Tests the actual WebSocket connection (Lambda is working, just missing welcome message)
 */

export const testWebSocketConnection = () => {
  console.log('🧪 Testing WebSocket connection to Codebase 1...');
  console.log('💡 Note: Lambda is working, just missing welcome message due to env var');
  
  // Test URL exactly as specified by Codebase 1
  const wsUrl = 'wss://lb9l475n95.execute-api.us-east-1.amazonaws.com/$default?type=customer&timestamp=' + Date.now();
  
  console.log('🔌 Test WebSocket URL:', wsUrl);
  console.log('📡 Expected: Connection will work, welcome message may fail');
  
  try {
    const ws = new WebSocket(wsUrl);
    
    ws.onopen = () => {
      console.log('✅ SUCCESS: WebSocket connected to Codebase 1!');
      console.log('🔗 Connection established - Lambda is working correctly');
      console.log('📝 Note: Welcome message may fail due to env var issue');
      
      // Send a test message to verify bidirectional communication
      const testMessage = {
        type: 'TEST_CONNECTION',
        message: 'Codebase 2 testing connection',
        timestamp: Date.now(),
        customerType: 'customer'
      };
      
      console.log('📤 Sending test message:', testMessage);
      ws.send(JSON.stringify(testMessage));
      
      // Keep connection open to test real-time functionality
      console.log('⏳ Keeping connection open for 30 seconds to test real-time updates...');
      console.log('💡 Add a vendor in Codebase 1 to see real-time events!');
      
      // Close after 30 seconds
      setTimeout(() => {
        console.log('🧪 Test complete, closing connection');
        ws.close();
      }, 30000);
    };
    
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log('📨 SUCCESS: Received message from Codebase 1:', data);
        
        // Check if this is a vendor event
        if (data.type === 'VENDOR_ADDED' || data.type === 'VENDOR_STATUS_CHANGED') {
          console.log('🎉 REAL-TIME VENDOR UPDATE RECEIVED!');
          console.log('🔗 merchantId:', data.vendor?.merchantId);
          console.log('🏪 Vendor:', data.vendor?.businessName);
        }
        
      } catch (error) {
        console.log('📨 Raw message received (may be welcome message):', event.data);
      }
    };
    
    ws.onclose = (event) => {
      console.log('🔌 WebSocket closed:', {
        code: event.code,
        reason: event.reason,
        wasClean: event.wasClean,
        timestamp: new Date().toISOString()
      });
      
      if (event.code === 1000) {
        console.log('✅ Clean close - test completed successfully');
      } else if (event.code === 1006) {
        console.log('⚠️ Connection lost - check network or Lambda timeout');
      } else {
        console.log('❌ Unexpected close code - may indicate an issue');
      }
    };
    
    ws.onerror = (error) => {
      console.error('❌ WebSocket error:', {
        error: error.message,
        timestamp: new Date().toISOString()
      });
    };
    
    // Connection timeout
    setTimeout(() => {
      if (ws.readyState === WebSocket.CONNECTING) {
        console.error('⏰ CONNECTION TIMEOUT: Taking too long to connect');
        console.log('🔍 This suggests the Lambda is not responding to WebSocket upgrade requests');
        ws.close();
      }
    }, 10000);
    
  } catch (error) {
    console.error('❌ Failed to create WebSocket:', error);
  }
};

export default testWebSocketConnection;
